export default __webpack_public_path__ + "static/media/bg3.3bcf9b1a.png";